import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'Components/UI';
import { dateUpdateListFiles } from 'Utils/DateUtils';
import { StatusType } from 'Data/interfaces/ListagemArquivos/IUpdateStatus';
import styles from './updateStatus.module.scss';

export interface IUpdateStatus {
  status?: StatusType;
  date: Date | string | null | undefined;
  loading: boolean;
  custom?: boolean;
}

const UpdateStatus: FC<IUpdateStatus> = ({
  status,
  date,
  loading,
  custom,
}) => {
  const { t } = useTranslation('sidebar');
  const formatedDate = new Date(date || new Date());

  if (loading && !custom) {
    return <></>
  }

  if (status === "atualizando") {
    return (
      <div className={styles['WrapperStatusUpdating']}>
        <p className={styles['updateStatus']}>
          {custom
            ? loading
              ? t('updateStatus.loading')
              : t('updateStatus.updating')
            : t('updateStatus.loading')

          }
        </p>
        <Icon
          color={custom ? 'primary' : 'cinzaSuperior'}
          icon="atualizar"
        />
      </div>
    )
  }

  if (status === "atualizado") {
    const result = dateUpdateListFiles(formatedDate, custom);
    const updatedText =
      result.kind === 'secondsAgo'
        ? t('updateStatus.secondsAgo')
        : result.kind === 'minutesAgo'
          ? t('updateStatus.minutesAgo')
          : t('updateStatus.updatedOn', { date: result.date });

    return (
      <div className={styles['WrapperStatus']}>
        <p className={styles['updateStatus']}>{updatedText}</p>
      </div>
    )
  }

  return (
    <div className={styles['WrapperStatus']}>
      <p className={styles['updateStatus']}>{t('updateStatus.errorReload')}</p>
      <Icon color="vermelho" icon="aviso" />
    </div>
  )
}

export default UpdateStatus;
